import { useMemo } from 'react';
import { useQuery } from 'urql';

import { SKILL_TAXONOMY_SECONDARY_SELECTION_LIST_QUERY } from '@revelio/data-access';

export const useCustomSkillSelectionList = (
  taxonomyId?: number,
  options?: { pause?: boolean }
) => {
  const pauseFromTaxonomyId = taxonomyId === undefined || taxonomyId === null;
  const pause = options?.pause === true || pauseFromTaxonomyId;

  return useQuery({
    query: SKILL_TAXONOMY_SECONDARY_SELECTION_LIST_QUERY,
    variables: {
      taxonomy_id: taxonomyId ?? 0,
      l0: 1,
      l1: 2,
      l2: 3,
      l3: 4,
      l4: 5,
    },
    pause,
    context: useMemo(() => ({ priority: 'low' as const }), []),
  });
};
